import { Component, OnInit, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { CtaButtonMultipleSelectGroupComponent } from "../cta-button-multiple-select-group/cta-button-multiple-select-group.component";

@Component({
    selector: "dodo-cta-button-multiple-select-group-control",
    templateUrl: "./cta-button-multiple-select-group-control.component.html",
    styleUrls: ["./cta-button-multiple-select-group-control.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CtaButtonMultipleSelectGroupControlComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CtaButtonMultipleSelectGroupControlComponent
	implements OnInit, ControlValueAccessor {
	private __cardGroup: CtaButtonMultipleSelectGroupComponent;

	_activeCardId: number;
	_inactiveCardId: number;
	_activeCardIds: number[];

	set activeCardId(id: number) {
		this._activeCardId = id;
		if (!(this._activeCardIds.indexOf(id) > -1)) {
			this._activeCardIds.push(id);
		}

		this.propagateChange(this._activeCardIds);
	}

	set inactiveCardId(id: number) {
		this._inactiveCardId = id;
		const cardIndex = this._activeCardIds.indexOf(id);
		if (cardIndex >= 0) {
			this._activeCardIds.splice(cardIndex, 1);
		}
		this.propagateChange(this._activeCardIds);
	}

	_disabled: boolean;

	constructor() {}

	ngOnInit() {
		this._activeCardIds = [];
	}

	propagateChange = (_: any) => {};

	writeValue(cardId: number): void {
		if (cardId !== undefined && cardId !== null) {
			this._activeCardId = cardId;
			if (this.__cardGroup) {
				this.__cardGroup.activeCardId = this._activeCardId;
			}
		}
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void {}

	setDisabledState?(isDisabled: boolean): void {
		this._disabled = isDisabled;
	}

	registerCardGroup(cardGroup: CtaButtonMultipleSelectGroupComponent) {
		this.__cardGroup = cardGroup;
		this.__cardGroup.cardSelected.subscribe((cardId: number) => {
			this.activeCardId = cardId;
		});

		this.__cardGroup.cardUnSelected.subscribe((cardId: number) => {
			this.inactiveCardId = cardId;
		});

		if (this._activeCardId) {
			this.__cardGroup.activeCardId = this._activeCardId;
		}
	}
}
